<template>
  <a
    v-if="item.externalTypeOfLink"
    class="widget-link"
    :href="item.url.path"
    rel="noopener noreferrer"
    target="_blank"
    @click="$emit('closeMenu')"
  >
    <div
      v-if="item.labels"
      class="widget-link__labels"
    >
      <span
        v-for="(label, key) in item.labels"
        :key="key"
        class="widget-link__label"
      >
        <component
          :is="labelIcon(label).componentName"
          v-if="labelIcon(label)"
          class="widget-link__label-icon"
        ></component>
        {{ label.name }}
      </span>
    </div>
    <div
      v-if="item.title"
      class="widget-link__title"
      :class="{'widget-link__title--bold' : titleBold}"
      v-html="item.title"
    ></div>
    <div
      v-if="item.description"
      class="widget-link__description"
      v-html="item.description"
    ></div>
  </a>

  <nuxt-link
    v-else
    class="widget-link"
    :to="{
      path: localePath(`${item.url.path}`),
      hash: item.url.hash ? `${item.url.hash}` : ''
    }"
    @click.native="$emit('closeMenu')"
  >
    <div
      v-if="item.labels"
      class="widget-link__labels"
    >
      <span
        v-for="(label, key) in item.labels"
        :key="key"
        class="widget-link__label"
      >
        <component
          :is="labelIcon(label).componentName"
          v-if="labelIcon(label)"
          class="widget-link__label-icon"
        ></component>
        {{ label.name }}
      </span>
    </div>
    <div
      v-if="item.title"
      class="widget-link__title"
      :class="{'widget-link__title--bold' : titleBold}"
      v-html="item.title"
    ></div>
    <div
      v-if="item.description"
      class="widget-link__description"
      v-html="item.description"
    ></div>
  </nuxt-link>
</template>

<script>
  import SvgLink from 'assets/icons/header/dropdown-menu/code.svg'
  import SvgClock from '~/assets/icons/header/dropdown-menu/clock.svg'
  import SvgMarker from '~/assets/icons/header/dropdown-menu/marker.svg'

  const icons = [
    {
      name: 'link',
      componentName: SvgLink
    },
    {
      name: 'clock',
      componentName: SvgClock
    },
    {
      name: 'marker',
      componentName: SvgMarker
    }
  ]

  export default {
    name: 'WidgetLink',
    components: {
      SvgLink,
      SvgClock,
      SvgMarker
    },
    props: {
      titleBold: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        default: () => {}
      }
    },
    data() {
      return {
        icons
      }
    },
    methods: {
      labelIcon(label) {
        return this.icons.find(icon => icon.name === label.iconName)
      }
    }
  }
</script>

<style lang="scss">
  .widget-link {
    display: inline-flex;
    flex-direction: column;
    padding: 12px 0;
    color: $primary;

    @include text--sm;
  }

  .widget-link__labels {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 8px;
    color: $primary65;

    @include text--xs;
  }

  .widget-link__label {
    display: inline-flex;
    align-items: center;

    &:not(:last-child) {
      margin-right: 12px;
    }
  }

  .widget-link__label-icon {
    display: block;
    max-width: 12px;
    max-height: 12px;
    margin-right: 6px;
    fill: $primary65;
  }

  .widget-link__title {
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;

    &--bold {
      font-weight: 600;
    }
  }

  .widget-link__description {
    margin-top: 8px;
    color: $primary;
  }
</style>